import React from "react";
import styles from "./GetStarted.module.css";

const GetStartedUpgrade = ({ width = 100, height = 100 }) => {
    return (
        <svg viewBox="0 0 100 100" width={width} height={height}>
            <path
                className={styles.cls1}
                d="M50,97.8A48.68,48.68,0,1,1,98.63,49.12,48.73,48.73,0,0,1,50,97.8ZM50,3.49A45.64,45.64,0,1,0,95.58,49.12,45.68,45.68,0,0,0,50,3.49Z"
            />
            <path
                className={styles.cls1}
                d="M58.92,70.09a.85.85,0,0,1-.52-.19L45.6,59.49,32.79,69.9a.84.84,0,0,1-.87.11.83.83,0,0,1-.47-.74V29.4a.82.82,0,0,1,.82-.82H58.92a.82.82,0,0,1,.82.82v7.77a.82.82,0,0,1-1.64,0v-7h-25V67.55l12-9.75a.83.83,0,0,1,1,0l12,9.75V56.82a.82.82,0,1,1,1.64,0V69.27a.83.83,0,0,1-.47.74A.85.85,0,0,1,58.92,70.09Z"
            />
            <path
                className={styles.cls1}
                d="M58.92,70.85a1.61,1.61,0,0,1-1-.36l-12.32-10-12.33,10a1.58,1.58,0,0,1-2.58-1.22V29.4a1.58,1.58,0,0,1,1.58-1.58H58.92A1.58,1.58,0,0,1,60.5,29.4v7.77a1.58,1.58,0,0,1-3.16,0V31H33.85v35L44.6,57.21a1.58,1.58,0,0,1,2,0l10.75,8.73V56.82a1.58,1.58,0,0,1,3.16,0V69.27a1.6,1.6,0,0,1-1.58,1.58ZM45.6,58.51,58.92,69.32h0l0-12.5-.12,12.33L45.63,58.39,32.33,69.15V29.46H58.86v7.71L59,29.4l-26.71,0-.06,39.92Z"
            />
            <path
                className={styles.cls1}
                d="M57.24,55.19a.79.79,0,0,1-.65-.33L47.87,43.49a3.28,3.28,0,0,1,5.2-4l3.53,4.62,7.95-13.55a3.28,3.28,0,1,1,5.65,3.32L57.94,54.78a.77.77,0,0,1-.65.4ZM50.46,39.86a1.64,1.64,0,0,0-1.29,2.63l8,10.41L68.79,33.06A1.64,1.64,0,0,0,66,31.4L57.4,46a.82.82,0,0,1-.66.41.83.83,0,0,1-.7-.32L51.77,40.5A1.65,1.65,0,0,0,50.46,39.86Z"
            />
            <path
                className={styles.cls1}
                d="M57.24,56A1.63,1.63,0,0,1,56,55.33L47.26,44A4,4,0,0,1,51,37.5,4,4,0,0,1,53.67,39l2.85,3.71,7.37-12.56a4,4,0,0,1,7,4.08L58.6,55.17a1.58,1.58,0,0,1-1.26.77ZM50.46,39a2.47,2.47,0,0,0-1.52.52A2.53,2.53,0,0,0,48.47,43l8.77,11.39v0L69.54,33.5A2.51,2.51,0,1,0,65.2,31L56.69,45.48,52.46,40a2.44,2.44,0,0,0-1.66-1Zm6.77,15.28L48.56,43A2.41,2.41,0,0,1,49,39.59a2.45,2.45,0,0,1,3.36.45l4.28,5.58L65.3,31a2.4,2.4,0,0,1,4.4.6,2.37,2.37,0,0,1-.26,1.82ZM50.46,40.62A.88.88,0,0,0,49.77,42l7.29,9.51L68.13,32.67a.89.89,0,0,0-.31-1.2.88.88,0,0,0-1.2.32L58.06,46.38a1.59,1.59,0,0,1-1.27.78,1.63,1.63,0,0,1-1.35-.62L51.16,41A.88.88,0,0,0,50.46,40.62Z"
            />
        </svg>
    );
};

export default GetStartedUpgrade;
